import { ReactComponent as PageLogo } from 'assets/icons/Charter_Hall_logo.svg';
import { ReactComponent as EditIcon } from 'assets/icons/Edit_icon.svg';
import { ReactComponent as InternalIcon } from 'assets/icons/Internal-icon-buttom.svg';
import { ReactComponent as LinkIcon } from 'assets/icons/Link-icon.svg';
import { ReactComponent as AdminIcon } from 'assets/icons/admin-logo.svg';
// import { ReactComponent as AnalyticsIcon } from "assets/icons/analytics-logo.svg";
import { ReactComponent as AddIcon } from 'assets/icons/AddIcon.svg';
import { ReactComponent as BgIconListWhite } from 'assets/icons/BgIconListWhite.svg';
import { ReactComponent as CheckedIcons } from 'assets/icons/CheckedIcons.svg';
import { ReactComponent as FolderIcons } from 'assets/icons/FolderIcon.svg';
import { ReactComponent as IconAddTopic } from 'assets/icons/Icons-add-topic.svg';
import { ReactComponent as UncheckedIcons } from 'assets/icons/UncheckedIcons.svg';
import { ReactComponent as TopicTitleIcon } from 'assets/icons/article-title-icon.svg';
import { ReactComponent as BackIconAdmin } from 'assets/icons/back-icon-admin.svg';
import { ReactComponent as BgListIcon } from 'assets/icons/bi_list-ul.svg';
import { ReactComponent as BuildcorpLogoBlack } from 'assets/icons/buildcorp-logo-black.svg';
import { ReactComponent as BuildcorpLogoWhite } from 'assets/icons/buildcorp-logo-white.svg';
import { ReactComponent as BxEditLinkIcon } from 'assets/icons/bx_edit_link.svg';
import { ReactComponent as IconCheckYellowCurrent } from 'assets/icons/clock-check-outline-yellow.svg';
import { ReactComponent as IconCheckGreenCurrent } from 'assets/icons/clock-check-outline.svg';
import { ReactComponent as DislikeIcon } from 'assets/icons/dislike.svg';
import { ReactComponent as DowloadIcon } from 'assets/icons/dowload-icon.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/email-icon.svg';
import { ReactComponent as NewFeedbackIcon } from 'assets/icons/feedback-icon.svg';
import { ReactComponent as FeedbackIcon } from 'assets/icons/feedback-logo.svg';
import { ReactComponent as HeartRedIcon } from 'assets/icons/heart-red-icon.svg';
import { ReactComponent as HomeIcon } from 'assets/icons/home-logo.svg';
import { ReactComponent as IconAddTopicDark } from 'assets/icons/icon-add-topic-dark.svg';
import { ReactComponent as ReturnIcon } from 'assets/icons/icon-park_return.svg';
import { ReactComponent as LessonsLearntLogo } from 'assets/icons/lesson_learn.svg';
import { ReactComponent as LikeIcon } from 'assets/icons/like.svg';
import { ReactComponent as MicrosoftIcon } from 'assets/icons/logo-microsoft.svg';
import { ReactComponent as LogoutIcon } from 'assets/icons/logout-logo.svg';
import { ReactComponent as MenuAdminIcon } from 'assets/icons/menu-admin-icon.svg';
import { ReactComponent as MenuContactsIcon } from 'assets/icons/menu-contacts-icon.svg';
import { ReactComponent as MenuDashboardIcon } from 'assets/icons/menu-dashboard-icon.svg';
import { ReactComponent as MenuLessonLearntIcon } from 'assets/icons/menu-lessons-learnt-icon.svg';
import { ReactComponent as MenuProactiveIcon } from 'assets/icons/menu-proactive-initiatives-icon.svg';
import { ReactComponent as MenuProjectsIcon } from 'assets/icons/menu-projects-icon.svg';
import { ReactComponent as MenuQualityIcon } from 'assets/icons/menu-quality-icon.svg';
import { ReactComponent as MenuSafetyIcon } from 'assets/icons/menu-safety-icon.svg';
import { ReactComponent as MoveIcon } from 'assets/icons/move-icon.svg';
import { ReactComponent as MenuNewsIcon } from 'assets/icons/news-icon.svg';
import { ReactComponent as NotificationIcon } from 'assets/icons/notification-icon.svg';
import { ReactComponent as OptionIcon } from 'assets/icons/option.svg';
import { ReactComponent as IconCancelCurrent } from 'assets/icons/pajamas-time-out.svg';
import { ReactComponent as HeartIcon } from 'assets/icons/ph_heart-bold.svg';
import { ReactComponent as PreviewIcon } from 'assets/icons/preview-icon.svg';
import { ReactComponent as PrivateIcon } from 'assets/icons/private-icon.svg';
import { ReactComponent as ReverseIcon } from 'assets/icons/reverse-icon.svg';
import { ReactComponent as ReviewIcon } from 'assets/icons/review-logo.svg';
import { ReactComponent as RoleIcon } from 'assets/icons/role-icon.svg';
import { ReactComponent as SaveDraftTopicReviewIcon } from 'assets/icons/save-draft-topic-review-icon.svg';
import { ReactComponent as SaveIcon } from 'assets/icons/save-icon-a.svg';
import { ReactComponent as SearchIconWhite } from 'assets/icons/search-icon-white.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search-icon.svg';
import { ReactComponent as SlashIcon } from 'assets/icons/slash-icon.svg';
import { ReactComponent as AnalyticsIcon } from 'assets/icons/solar_chart-bold.svg';
import { ReactComponent as SubmitTopicReviewIcon } from 'assets/icons/submit-topic-review-icon.svg';
import { ReactComponent as TopicIcon } from 'assets/icons/topic-icon.svg';
import { ReactComponent as User2Icon } from 'assets/icons/user-logo.svg';
import { ReactComponent as UserIcon } from 'assets/icons/users-icon.svg';
import { ReactComponent as ScrollTop } from 'assets/icons/scroll_top.svg';
import { ReactComponent as Breadcrumbs } from 'assets/icons/Breadcrumbs.svg';
import { ReactComponent as BarsScale } from 'assets/icons/bars-scale.svg';
import { ReactComponent as SuccessIcon } from 'assets/icons/Succeess.svg.svg';
import { ReactComponent as ErrorIcon } from 'assets/icons/Error.svg.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/Warning.svg.svg';
import { ReactComponent as EditTopicsIcon } from 'assets/icons/Edit-Topic-Icon.svg';
import { ReactComponent as LikeIconActive } from 'assets/icons/icon-like-active.svg';
import { ReactComponent as NodataPieChart } from 'assets/icons/NodataPieChart.svg';
import { ReactComponent as PrintIcon } from 'assets/icons/icon-print.svg';
import { ReactComponent as ExcelIcon } from 'assets/icons/icon-excel.svg';
import { ReactComponent as CheckedIconsBlack } from 'assets/icons/CheckedIcons_black.svg';
import { ReactComponent as CheckedIconsOutLineBlack } from 'assets/icons/CheckedIcons_out_line_black.svg';
import { ReactComponent as SearchIconDefault } from 'assets/icons/search-df.svg';

const Icons = {
  SuccessIcon,
  ErrorIcon,
  WarningIcon,
  BuildcorpLogoBlack,
  MicrosoftIcon,
  BuildcorpLogoWhite,
  MenuAdminIcon,
  MenuContactsIcon,
  MenuLessonLearntIcon,
  MenuProjectsIcon,
  MenuSafetyIcon,
  MenuQualityIcon,
  MenuProactiveIcon,
  MenuDashboardIcon,
  LessonsLearntLogo,
  PageLogo,
  MenuNewsIcon,
  EmailIcon,
  UserIcon,
  ReturnIcon,
  HeartIcon,
  AdminIcon,
  AnalyticsIcon,
  User2Icon,
  FeedbackIcon,
  NewFeedbackIcon,
  ReviewIcon,
  HomeIcon,
  LogoutIcon,
  EditIcon,
  InternalIcon,
  DowloadIcon,
  LinkIcon,
  SaveIcon,
  RoleIcon,
  LikeIcon,
  DislikeIcon,
  OptionIcon,
  BgListIcon,
  SlashIcon,
  MoveIcon,
  NotificationIcon,
  PrivateIcon,
  SearchIcon,
  BgIconListWhite,
  HeartRedIcon,
  ReverseIcon,
  SearchIconWhite,
  BackIconAdmin,
  FolderIcons,
  AddIcon,
  IconAddTopic,
  IconAddTopicDark,
  IconCheckGreenCurrent,
  IconCancelCurrent,
  IconCheckYellowCurrent,
  CheckedIcons,
  SaveDraftTopicReviewIcon,
  SubmitTopicReviewIcon,
  TopicTitleIcon,
  PreviewIcon,
  TopicIcon,
  UncheckedIcons,
  BxEditLinkIcon,
  ScrollTop,
  Breadcrumbs,
  BarsScale,
  EditTopicsIcon,
  LikeIconActive,
  NodataPieChart,
  PrintIcon,
  ExcelIcon,
  CheckedIconsBlack,
  CheckedIconsOutLineBlack,
  SearchIconDefault
};

export default Icons;
